import { TypeCategoryWithoutUnresolvableLinksResponse } from 'bb-contentful-types'
import { FlexGrid } from '@telus-uds/components-web'
import PaginationPreview from './PaginationPreview'
import ShowMorePreview from './ShowMorePreview'
import HeadingPreview from './HeadingPreview'
import type { Language } from '@/siteBuilder/locale'
import type { BlogUrl } from 'src/blogBuilder/utils/blogUrl'
import { PreviewContainerWhiteBackground, PreviewContainerGrayBackground } from './styles'
import { filterTags } from '@/blogBuilder/utils/types/theme'

export type PreviewProps = {
  blogs: TypeCategoryWithoutUnresolvableLinksResponse[]
  lang: Language
  fullBlogUrls: BlogUrl
  theme: 'blog' | 'story'
  navigationOptions?: 'Show More' | 'Pagination'
  filterTags: { tags: filterTags; category: string }[]
}

const Preview = ({ blogs, lang, fullBlogUrls, theme, navigationOptions, filterTags }: PreviewProps) => {
  const PreviewContainer = theme === 'story' ? PreviewContainerWhiteBackground : PreviewContainerGrayBackground

  return (
    <>
      <PreviewContainer data-testid="bb-story-preview">
        <FlexGrid>
          {theme === 'story' && <HeadingPreview filterTags={filterTags} lang={lang} />}

          {navigationOptions === 'Pagination' ? (
            <PaginationPreview blogs={blogs} lang={lang} fullBlogUrls={fullBlogUrls} theme={theme} />
          ) : (
            <ShowMorePreview blogs={blogs} lang={lang} fullBlogUrls={fullBlogUrls} theme={theme} />
          )}
        </FlexGrid>
      </PreviewContainer>
    </>
  )
}

export default Preview
